import Button from '@components/Button'
import Prompt from '@components/Prompt'
import { Avatar, Stack, Typography, useTheme } from '@mui/material'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { HiMiniExclamationTriangle } from 'react-icons/hi2'

interface Props {
  visible?: boolean
  title?: string
  description?: string
  onDismiss?: () => void
}

const ErrorPopup: FC<Props> = ({ visible, title, description, onDismiss }) => {
  const { palette } = useTheme()
  const { t } = useTranslation()

  return (
    <Prompt show={!!visible}>
      <Stack alignItems="center" spacing={2}>
        <Avatar sx={{ bgcolor: 'background.default', width: 50, height: 50 }}>
          <HiMiniExclamationTriangle color={palette.rainbow.yellow} size={30} />
        </Avatar>
        <Stack alignItems="center" spacing={1}>
          <Typography variant="h6">{title}</Typography>
          <Typography textAlign="center">{description}</Typography>
        </Stack>
        <Button onClick={onDismiss} variant="rainbow">
          {t('common.understood')}
        </Button>
      </Stack>
    </Prompt>
  )
}

export default ErrorPopup
